export const configEnv = {
	CONTRACT_ADDRESS: '0xa8a1a33EbD2A5A8872c8Cc991478b4F968F90de4',
	// AVAX_CHAINID: 43113,
	AVAX_CHAINID:43114, // for mainnet
	// AVAX_RPC: 'https://api.avax-test.network/ext/bc/C/rpc', //For mainnet
	AVAX_RPC:"https://api.avax.network/ext/bc/C/rpc", //For mainnet
	AVAX_CONTRACT_ADDRESS_URL:
		'https://snowtrace.io/address/0xa8a1a33EbD2A5A8872c8Cc991478b4F968F90de4#code', //Changed for mainnet,
	AVAX_NETWORK_ID: 'avax',
	AVAX_NETWORK_NAME: 'Avax Mainnet',
	REF_ADDRESS: '0x0000000000000000000000000000000000000000',
};
